import { render, staticRenderFns } from "./ProgramGeographicMetricWidget.vue?vue&type=template&id=2deea102&scoped=true&lang=pug&"
import script from "./ProgramGeographicMetricWidget.vue?vue&type=script&lang=js&"
export * from "./ProgramGeographicMetricWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProgramGeographicMetricWidget.vue?vue&type=style&index=0&id=2deea102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deea102",
  null
  
)

export default component.exports